import { subject } from "@casl/ability";
import { faPlus } from "@fortawesome/sharp-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useNavigate } from "@tanstack/react-router";
import { Button, cn } from "frontend-components";
import { useTranslation } from "react-i18next";
import { useHseInstance } from "@dashboard/hooks/useHseInstance";
import { Can } from "@dashboard/casl/taskAbility";

type NewActivityButtonProps = {
    iconOnly?: boolean;
    className?: string;
};

export function NewActivityButton({ iconOnly = false, className }: NewActivityButtonProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { instanceId } = useHseInstance();

    const openCreateModal = () => {
        void navigate({
            to: ".",
            search: (prev) => ({ ...prev, task: "new", edit: undefined }),
        });
    };

    return (
        <Can I="create" this={subject("Task", { instanceId })}>
            {iconOnly ? (
                <Button
                    type="button"
                    variant="fill"
                    size="arrow"
                    aria-label={t("task.newActivity")}
                    className={className}
                    onClick={openCreateModal}
                >
                    <FontAwesomeIcon icon={faPlus} />
                </Button>
            ) : (
                <Button
                    type="button"
                    className={cn(
                        "rounded-pill bg-compendia-foreground text-white hover:bg-compendia-foreground/90 px-5 py-2 text-sm font-semibold",
                        className,
                    )}
                    onClick={openCreateModal}
                >
                    <FontAwesomeIcon icon={faPlus} />
                    {t("task.newActivity")}
                </Button>
            )}
        </Can>
    );
}
